<template>
  <v-container>

      <v-row
        no-gutters
      >
        <v-col cols="12" md="2">
          <v-select
              v-model="category_selected"
              :items="categories"
              label="Selecciona Categoria"
            ></v-select>
        </v-col>
        <v-col cols="12" md="2" offset-md="1">
          <v-select
              v-model="gender_selectd"
              :items="genders"
              label="Selecciona Genero"
            ></v-select>
        </v-col>
   <v-col cols="12" md="2" offset-md="1">
          <v-select
              v-model="elo_selected"
              :items="elos"
              label="Selecciona Elo"
            ></v-select>
        </v-col>
        <v-col cols="12" md="2" offset-md="1">
          <v-select
              v-model="region_selected"
              :items="regions"
              label="Selecciona Region"
            ></v-select>

        </v-col>
      </v-row>
    </v-container>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          ELO Nacional
        </th>
        <th class="text-center">
          ELO Fide
        </th>
        <th class="text-center">
          Fed. Id
        </th>
        <th class="text-center">
          Fecha Nacimiento
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in players"
        :key="item.id"
      >
        <td class="text-left" style="width: 800px"><a :href="'/player/'+item.id" style="color:blue">{{ item.full_name }}</a></td>
        <td class="text-center">{{ item.elo_nat }}</td>
        <td class="text-center">{{ item.elo_inter }}</td>
        <td class="text-center">{{ item.federation_id }}</td>
        <td class="text-center">{{ item.birthday_formated }}</td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
  import gql from "graphql-tag";
  import { vue3Debounce } from 'vue-debounce'
  import {mapState} from "vuex";
  export default {
    directives: {
    debounce: vue3Debounce({ lock: true })
  },
    apollo: {
    data_response: {query: gql` query($id:String!,$gender:String!,$elo:String!,$region:String!){
       person_ranking:personRanking(id:$id,gender:$gender,elo:$elo,region:$region){
        id
        title
        full_name:fullName
        birthday_formated:birthdayFormated
        club:clubBasic {
          name
        }
        federation_id:federationId
        elo_nat:eloNat
        elo_inter:eloInter
      }
      regions {
        value:id
        title:name
      }
      category_players:categoryPlayers{
        value:id
        title:name
      },
    }`,
      variables() {return {"id" :this.category_selected+"","gender" :this.gender_selectd,"elo" :this.elo_selected+"","region" :this.region_selected+"",}},
      update(data) {
      console.log("acaa en data",data)
        this.players = data.person_ranking
        this.categories = data.category_players;
        this.regions = data.regions;
    }
    },
  },
    name:"SeeRankingPlayer",
    data () {
      return {
        players:null,
        download:false,
        search_first_name:"",
        search_last_name:"",
        search_last_name_second:"",
        last_name_net:"",
        last_name_second_net:"",
        first_name_net:"",
        categories:[],
        regions: [],
        genders: ["Open","Femenino"],
        elos:["Nacional","Internacional"],
        category_selected: "1",
        region_selected: "",
        elo_selected:"Nacional",
        gender_selectd:"Open"
      }
    },
    computed: {
    ...mapState(['is_authenticated']),
  },
    methods: {
    performSearchFirstName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.first_name_net = newVal;
    },
    performSearchLastName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.last_name_net = newVal;
    },
      performSearchLastSecondName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.last_name_second_net = newVal;
    },
      redirect(id){
        if(id){
          window.location.href = '/crear_jugador/' + id
        } else {
          window.location.href = '/crear_jugador'
        }
      },
  },
  }
</script>

